import Konva from 'konva';
import React, { forwardRef, memo } from 'react';
import { Image as KonvaImage } from 'react-konva';
import { DEFAULT_MAP_CONFIG, MapImageConfig } from '../model/mapConfigSerialization';
import { WarehouseMapTool } from '../model/types';

interface ConstructorBackgroundProps {
  image: CanvasImageSource | undefined;
  transform?: MapImageConfig;
  activeTool?: WarehouseMapTool;
  onDragEnd?: (x: number, y: number) => void;
  onTransformEnd?: (rotation: number) => void;
}

export const ConstructorBackground = memo(
  forwardRef<Konva.Image, ConstructorBackgroundProps>((props, ref) => {
    const { image, transform = DEFAULT_MAP_CONFIG.image, activeTool = WarehouseMapTool.POINTER, onDragEnd, onTransformEnd } = props;
    const editable = activeTool === WarehouseMapTool.EDIT_BACKGROUND && !transform.locked;

    return (
      <KonvaImage
        ref={ref}
        name="background-image"
        image={image}
        x={transform.x}
        y={transform.y}
        rotation={transform.rotation}
        opacity={transform.opacity}
        listening={editable}
        draggable={editable}
        onDragEnd={(event) => {
          onDragEnd?.(event.target.x(), event.target.y());
        }}
        onTransformEnd={(event) => {
          onTransformEnd?.(event.target.rotation());
        }}
      />
    );
  }),
);
